/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { request } from '@mairistem/tools';
import { useEntiteStore, useParametresStore } from '@/zustand';
import { baseUrlApp, getParametrage } from '@/routes';
import type { ApiResponse, ParametresGeneraux } from '@/types';

interface ParametresZustandProviderProps {
  children: React.ReactNode;
}

const ParametresZustandProvider = (props: ParametresZustandProviderProps) => {
  const { children } = props;

  const setParametres = useParametresStore((state) => state.setParametres);
  const parametres = useParametresStore((state) => state.parametres);
  const entiteSelected = useEntiteStore((state) => state.selectedEntite);

  const history = useHistory();

  React.useEffect(() => {
    if (_.isNil(parametres) && !_.isNil(entiteSelected)) {
      request
        .get(getParametrage())
        .then(({ data }: ApiResponse<ParametresGeneraux>) => {
          const parametre: ParametresGeneraux = data?.[0] || null;
          setParametres(parametre);
          if (_.isNil(parametre)) {
            history.push(`${baseUrlApp}parametres/generaux`);
          }
        });
    }
  }, [entiteSelected, history, parametres, setParametres]);

  return children;
};

export default ParametresZustandProvider;
